// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__JsUem","footer":"ModalUpdate_footer__2HC_B"};